import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Collaborateur, CollaborateurPayload } from '../models/collaborateur';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CollaborateurService {

  private apiUrl = `${environment.baseUrlApi}/collaborateur`;

  constructor(private http: HttpClient) {}

  /**
   * GET /api/collaborateur/all
   * Liste tous les collaborateurs parents (fixes)
   */
  getAll(): Observable<Collaborateur[]> {
    return this.http.get<Collaborateur[]>(`${this.apiUrl}/all`);
  }

  /**
   * GET /api/collaborateur/{id}/sous-collaborateurs
   * Liste des sous-collaborateurs d'un collaborateur
   */
  getSousCollaborateurs(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}/sous-collaborateurs`);
  }

  /**
   * GET /api/collaborateur/{id}
   * Détail d'un sous-collaborateur
   */
  getById(id: number): Observable<Collaborateur> {
    return this.http.get<Collaborateur>(`${this.apiUrl}/${id}`);
  }

  /**
   * POST /api/collaborateur/add
   * Ajouter un sous-collaborateur
   */
  create(payload: CollaborateurPayload): Observable<Collaborateur> {
    return this.http.post<Collaborateur>(`${this.apiUrl}/add`, payload);
  }

  /**
   * PUT /api/collaborateur/update/{id}
   * Modifier un sous-collaborateur
   */
  update(id: number, payload: CollaborateurPayload): Observable<Collaborateur> {
    return this.http.put<Collaborateur>(`${this.apiUrl}/update/${id}`, payload);
  }

  /**
   * DELETE /api/collaborateur/delete/{id}
   * Supprimer un sous-collaborateur
   */
  delete(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/delete/${id}`);
  }
}